import { Currency } from '@/core/currency/interfaces';

const SAR: Currency = {
    name: 'Saudi Riyal',
    demonym: 'Saudi',
    majorSingle: 'Riyal',
    majorPlural: 'Riyals',
    codeNumeric: '682',
    symbol: 'SR',
    symbolNative: 'ر.س.',
    minorSingle: 'Halalah',
    minorPlural: 'Halalahs',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SAR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SAR;
